export default "__VITE_ASSET__D64HVbRb__"